import ResponsiveBox from './ResponsiveBox.view';

export default ResponsiveBox;
